
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'KDIGOAKI',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Renal/KDIGOAKI.vue